import { usePunditUserContext } from "@circle-react/contexts";

export const useIsPaywallUpsellsEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  return Boolean(currentCommunitySettings?.paywall_upsells_enabled);
};
